::ng-deep particle-task-alert-send-notification-now-grid{display:flex;flex-grow:1}::ng-deep .avoid-clicks{pointer-events:none!important;background:var(--surface-page, #fafafa)}::ng-deep .avoid-clicks td{opacity:.4}
/*# sourceMappingURL=task-alert-send-notification-now-grid.component-OW7XK33W.css.map */
